import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const inp = "w-full border border-brand-gold-light/50 rounded px-3 py-2 text-sm bg-white outline-none focus:border-brand-gold";

export default function Settings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/site-settings").then(({ data }) => setS({ site_name: "", tagline: "", email: "", phone: "", address: "", maps_url: "", ...data })).catch(() => {}); }, []);

  const save = async () => {
    try { await api.put("/admin/site-settings", { data: s }); toast.success("Ayarlar kaydedildi."); }
    catch { toast.error("Kayıt başarısız."); }
  };

  if (!s) return <p className="text-brand-text/50">Yükleniyor…</p>;

  return (
    <div data-testid="admin-settings" className="max-w-2xl">
      <h1 className="font-serif text-4xl text-brand-green mb-6">Site Ayarları</h1>
      <div className="bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-8 space-y-4">
        {[["site_name", "Site Adı"], ["tagline", "Slogan"], ["email", "E-posta"], ["phone", "Telefon"], ["maps_url", "Google Maps URL"]].map(([k, l]) => (
          <div key={k}><label className="block text-sm font-medium mb-1">{l}</label><input value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} className={inp} data-testid={`settings-${k}`} /></div>
        ))}
        <div><label className="block text-sm font-medium mb-1">Adres</label><textarea value={s.address || ""} onChange={(e) => setS({ ...s, address: e.target.value })} className={inp} rows={3} /></div>
        <button onClick={save} data-testid="settings-save" className="bg-brand-gold text-brand-offwhite px-6 py-2.5 rounded-sm text-sm">Kaydet</button>
      </div>
    </div>
  );
}
